// The Spotters — shared order fulfilment metadata (mirrors backend state machine).

export const STATUS_META = {
  pending_payment:        { label: "Payment pending",              tone: "warn" },
  ordered:                { label: "Payment verified",             tone: "info" },
  admin_verified:         { label: "Verified — released",          tone: "info" },
  packing:                { label: "Packing",                      tone: "info" },
  ready_to_dispatch:      { label: "Ready to dispatch",            tone: "info" },
  dispatched:             { label: "Dispatched",                   tone: "info" },
  in_transit:             { label: "In transit",                   tone: "info" },
  out_for_delivery:       { label: "Out for delivery",             tone: "info" },
  delivered:              { label: "Delivered",                    tone: "good" },
  completed:              { label: "Completed",                    tone: "good" },
  cancelled:              { label: "Cancelled",                    tone: "bad" },
  rto_in_transit:         { label: "RTO — in transit",             tone: "warn" },
  rto_delivered:          { label: "RTO — returned to vendor",     tone: "warn" },
  return_requested:       { label: "Return requested",             tone: "warn" },
  return_shipped:         { label: "Return shipped",               tone: "warn" },
  return_received:        { label: "Return received",              tone: "warn" },
  return_vendor_approved: { label: "Return approved (vendor)",     tone: "warn" },
  return_vendor_rejected: { label: "Return rejected (vendor)",     tone: "warn" },
  return_disputed:        { label: "Return disputed",              tone: "bad" },
  return_admin_approved:  { label: "Return approved (admin)",      tone: "warn" },
  return_admin_rejected:  { label: "Return rejected (admin)",      tone: "warn" },
  refunded:               { label: "Refunded",                     tone: "good" },
  credit_issued:          { label: "Store credit issued",          tone: "good" },
};

export const statusLabel = (s) => (STATUS_META[s]?.label) || String(s || "").replace(/_/g, " ");
export const statusTone = (s) => (STATUS_META[s]?.tone) || "neutral";

export const RETURN_STATUSES = [
  "return_requested", "return_shipped", "return_received",
  "return_vendor_approved", "return_vendor_rejected", "return_disputed",
  "return_admin_approved", "return_admin_rejected",
];
export const isReturn = (s) => RETURN_STATUSES.includes(s);
export const isClosed = (s) => ["completed", "cancelled", "refunded", "credit_issued", "return_admin_rejected"].includes(s);

// The canonical forward journey, for rendering a stepper.
export const FORWARD_STEPS = [
  { key: "ordered",           label: "Placed" },
  { key: "admin_verified",    label: "Verified" },
  { key: "packing",           label: "Packing" },
  { key: "ready_to_dispatch", label: "Ready" },
  { key: "dispatched",        label: "Dispatched" },
  { key: "in_transit",        label: "In transit" },
  { key: "delivered",         label: "Delivered" },
  { key: "completed",         label: "Completed" },
];
const FORWARD_INDEX = FORWARD_STEPS.reduce((m, s, i) => ((m[s.key] = i), m), {});
// Statuses that map onto a forward step for the stepper's "current" marker.
export const forwardIndexOf = (status) => {
  if (status === "out_for_delivery") return FORWARD_INDEX.in_transit;
  if (status === "pending_payment") return -1;
  return FORWARD_INDEX[status] ?? -1;
};

// Tailwind classes for a status pill by tone.
export const toneClasses = (tone) => ({
  neutral: "border-foreground/40 text-foreground",
  info:    "border-foreground bg-foreground text-background",
  good:    "border-[hsl(var(--accent))] bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))]",
  warn:    "border-[hsl(var(--accent))] text-[hsl(var(--accent))]",
  bad:     "border-destructive text-destructive",
}[tone] || "border-foreground/40");

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");
